import Something from "../features/something";
import { Container } from "react-bootstrap";

export default function Tabulate() {
  return (
    <Container>
      <h1>Tabulate</h1>
      <Something />
    </Container>
  )
}
